import { render, staticRenderFns } from "./SalesDetailDialog.vue?vue&type=template&id=287faadc&scoped=true"
import script from "./SalesDetailDialog.vue?vue&type=script&lang=ts"
export * from "./SalesDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./SalesDetailDialog.vue?vue&type=style&index=0&id=287faadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287faadc",
  null
  
)

export default component.exports